import React, { useEffect, useState } from "react";
import {
  CloseOutlined,
  DownOutlined,
  SearchOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { getSubstores } from "../API  Functions/ProfileFunctions";
import LoadingSpinner from "../components/Loading";
import i18next from "i18next";
import {
  AutoComplete,
  Checkbox,
  ConfigProvider,
  Input,
  Radio,
  Select,
} from "antd";
import { heIL } from "@mui/x-date-pickers/locales";
import { height } from "@mui/system";
import { getProductGroups } from "../API  Functions/productGroupFunctions";
import { useSelector } from "react-redux";
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    width: "50%",
    maxHeight: "92vh", // 👈 this is the missing piece
    padding: "30px",
    borderRadius: "18px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    overflow: "scroll", // 👈 important
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "10px",
  },
  cancelIcon: {
    cursor: "pointer",
  },
  data: {
    height: "500px",
  },
};

const CheckboxRow = ({ checked, onChange, label }) => (
  <label className="flex items-center gap-2 cursor-pointer select-none my-1">
    <Checkbox
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="custom-blue-checkbox"
    />
    <span className="text-gray-800">{label}</span>
  </label>
);

const ExportInventoryModal = ({
  isOpen,
  onClose,
  onExport,
  exportFields,
  masterStore,
  is_master_Store,
}) => {
  const { t, i18n } = useTranslation();
  const [fields, setFields] = useState([]);
  const [stores, setStores] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [step, setStep] = useState(1); // Step 1 = stores, Step 2 = fields
  const [loading, setLoading] = useState(false);
  const [openGroups, setOpenGroups] = useState({});
  const [quantityFilter, setQuantityFilter] = useState("all");
  const [groupSearch, setGroupSearch] = useState(""); // search
  const [selectedGroups, setSelectedGroups] = useState([]); // multi select
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [groupDropdownOpen, setGroupDropdownOpen] = useState(false);
  const [groupDataLocal, setGroupDataLocal] = useState({});
  const [allGroupIds, setGroupIds] = useState([]);
  const [filteredGroups, setFilteredGroup] = useState([]);
  const isAllSelected = selectedGroupIds.length === allGroupIds.length;
  const isNoneSelected = selectedGroupIds.length === 0;
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  // Group Name is checked only when none are selected
  const isGroupNameChecked = isNoneSelected;

  const toggleGroup = (key) => {
    setOpenGroups((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    if (isOpen) {
      setFields([
        "barcode",
        "product_name",
        "product_name2",
        "quantity",
        "sale_price",
        "cost_price",
        "product_shortcut",
        "group_name",
      ]);
      setStep(is_master_Store ? 1 : 2); // Skip store selection if no master store
      if (is_master_Store) fetchSubStores();
    }
  }, [isOpen]);

  const loadGroupData = async () => {
    try {
      const responses = await Promise.all(
        selectedStores.map((storeId) => fetchGroupsByStore(storeId))
      );
      const allGroups = responses.flat(); // flatten arrays

      const uniqueGroups = Array.from(
        new Map(allGroups.map((item) => [item.id, item])).values()
      );
      const allGroupIdsLocal = uniqueGroups.map((g) => g.id);
      const filteredGroupsLocal = uniqueGroups?.filter((g) =>
        g.name.toLowerCase().includes(groupSearch.toLowerCase())
      );
      setFilteredGroup(filteredGroupsLocal);
      setGroupIds(allGroupIdsLocal);
      setGroupDataLocal(uniqueGroups);
    } catch (error) {
      console.error("Failed to load groups", error);
    }
  };

  const fetchGroupsByStore = (storeId) => {
    let payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: storeId,
      user_id: user_id,
      offset: 0,
      limit: 1000,
    };

    return getProductGroups(payload).then((res1) => {
      if (res1?.result?.[0]?.status_code === 200) {
        return res1?.result?.[0]?.product_groups || [];
      }
      return [];
    });
  };

  const fetchSubStores = async () => {
    setLoading(true);
    if (!masterStore) {
      setLoading(false);
      return;
    }
    try {
      const res = await getSubstores(masterStore.store_id);
      const substoresList = res?.response || [];
      const fullList = [
        masterStore,
        ...substoresList.filter((s) => s.store_id !== masterStore.store_id),
      ];
      setStores(fullList);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching substores:", err);
    }
  };

  const handleStoreChange = (storeId) => {
    if (storeId === "all") {
      setSelectedStores((prev) =>
        prev.length === stores.length ? [] : stores.map((s) => s.store_id)
      );
    } else {
      setSelectedStores((prev) =>
        prev.includes(storeId)
          ? prev.filter((id) => id !== storeId)
          : [...prev, storeId]
      );
    }
  };

  const handleCheckboxChange = (field) => {
    setFields((prev) =>
      prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field]
    );
  };

  const handleNext = () => {
    loadGroupData();
    setStep(2);
  };
  const handleBack = () => setStep(1);
  const SelectGroups = (id) => {
    setSelectedGroupIds((prev) => {
      let updated;

      if (prev.includes(id)) {
        updated = prev.filter((g) => g !== id);
      } else {
        updated = [...prev, id];
      }

      // If nothing selected → uncheck main
      if (updated.length === 0) {
        // setFields((prevFields) => prevFields.filter((f) => f == "group_name"));
      } else {
        // At least one selected → ensure main checked
        setFields((prevFields) =>
          prevFields.includes("group_name")
            ? prevFields
            : [...prevFields, "group_name"]
        );
      }

      return updated;
    });
  };

  const toggleAllGroups = () => {
    if (isAllSelected) {
      setSelectedGroupIds([]); // back to Group Name
    } else {
      setSelectedGroupIds(allGroupIds); // All groups
    }

    setFields((prev) => [...new Set([...prev, "group_name"])]);
  };

  const handleGroupNameToggle = () => {
    const isChecked = fields.includes("group_name");

    if (isChecked) {
      // turning OFF
      setFields((prev) => prev.filter((f) => f !== "group_name"));
      setSelectedGroupIds([]); // clear all
    } else {
      // turning ON
      setFields((prev) => [...prev, "group_name"]);
      // setSelectedGroupIds(groupDataLocal.map((g) => g.id)); // select all
    }
  };

  const selectedGroupTags = filteredGroups
    .filter((g) => selectedGroupIds.includes(g.id))
    .map((g) => ({
      value: g.id.toString(),
      label: i18n.language === "ar" ? g.name_ar : g.name,
    }));

  return (
    isOpen && (
      <>
        {loading && <LoadingSpinner />}
        <div style={styles.overlay} onClick={onClose}></div>
        <div style={styles.container}>
          <div style={styles.header}>
            <p style={styles.title}>{t("Export Inventory")}</p>
            <CloseOutlined style={styles.cancelIcon} onClick={onClose} />
          </div>

          {/* Step 1: Store Selection */}
          {step === 1 && is_master_Store && (
            <>
              <h2 className="text-base mb-2 italic text-gray-600">
                {t("Select the stores from which to export inventory data")}
              </h2>
              <div className="border border-gray-300 rounded-lg p-4 max-h-64 overflow-y-auto bg-gray-50">
                <CheckboxRow
                  checked={selectedStores.length === stores.length}
                  onChange={() => handleStoreChange("all")}
                  label={t("All Stores")}
                />

                {stores.map((store) => (
                  <CheckboxRow
                    checked={selectedStores.includes(store.store_id)}
                    onChange={() => handleStoreChange(store.store_id)}
                    label={
                      i18next.language === "ar"
                        ? store.store_name_ar
                        : store.store_name
                    }
                  />
                ))}
              </div>

              {/* Buttons */}
              <div className="grid grid-cols-3 gap-4 pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  className="w-full px-2 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  {t("Cancel")}
                </button>
                <button
                  disabled={selectedStores.length === 0}
                  onClick={handleNext}
                  className={`w-full px-2 py-2 rounded-lg font-semibold text-white ${
                    selectedStores.length === 0
                      ? "bg-primaryBlue opacity-50 cursor-not-allowed"
                      : "bg-primaryBlue hover:bg-[#13316a]"
                  }`}
                >
                  {t("Next")}
                </button>
              </div>
            </>
          )}

          {/* Step 2: Field Selection */}
          {step === 2 && (
            <>
              <h2 className="text-base mb-2 italic text-gray-600">
                {t("Select Fields to Export")}
              </h2>
              <div
                className="border border-gray-200 rounded-xl bg-gray-50 space-y-1 overflow-y-auto p-4"
                style={styles.data}
              >
                {exportFields.map((field) => {
                  const isGroup = field.children?.length > 0;
                  const isOpen = openGroups[field.key];

                  return (
                    <div key={field.key}>
                      {/* MAIN ROW */}
                      <div className="flex items-center justify-between">
                        {field.key === "group_name" ? (
                          <CheckboxRow
                            checked={fields.includes("group_name")}
                            onChange={handleGroupNameToggle}
                            label={field.label}
                          />
                        ) : (
                          <CheckboxRow
                            checked={fields.includes(field.key)}
                            onChange={() => handleCheckboxChange(field.key)}
                            label={field.label}
                          />
                        )}

                        {field.key === "group_name" && (
                          <button
                            onClick={() => toggleGroup(field.key)}
                            className="text-gray-500 hover:text-blue-600 flex items-center gap-1"
                          >
                            {t("Select group")}
                            {isOpen ? <UpOutlined /> : <DownOutlined />}
                          </button>
                        )}
                      </div>

                      {/* QUANTITY OPTIONS */}
                      {isGroup &&
                        field.key === "quantity" &&
                        fields.includes("quantity") && (
                          <div className="ml-7 p-3 bg-blue-50/50 rounded-lg border border-blue-100">
                            <Radio.Group
                              value={quantityFilter}
                              onChange={(e) =>
                                setQuantityFilter(e.target.value)
                              }
                              className="w-full"
                            >
                              <div className="grid grid-cols-3 gap-2">
                                {field.children.map((child) => (
                                  <Radio
                                    key={child.key}
                                    value={child.key}
                                    className="custom-blue-radio"
                                  >
                                    {child.label}
                                  </Radio>
                                ))}
                              </div>
                            </Radio.Group>
                          </div>
                        )}

                      {/* GROUP NAME OPTIONS */}
                      {field.key === "group_name" && isOpen && (
                        <div className="ml-7 p-3 bg-blue-50/50 rounded-lg border border-blue-100 space-y-2">
                          {/* ALL GROUPS */}
                          <CheckboxRow
                            label={t("All Groups")}
                            checked={
                              selectedGroupIds.length === groupDataLocal.length
                            }
                            onChange={toggleAllGroups}
                          />

                          <div className="border-t border-blue-200" />

                          {/* GROUP LIST (NO inner scroll!) */}
                          <Select
                            mode="multiple"
                            value={selectedGroupTags}
                            open={groupDropdownOpen}
                            style={{ width: "100%" }}
                            showSearch
                            optionFilterProp="label"
                            onDropdownVisibleChange={(open) =>
                              setGroupDropdownOpen(open)
                            }
                            onSearch={(val) => setGroupSearch(val)}
                            options={filteredGroups.map((group) => ({
                              value: group.id.toString(),
                              label: (
                                <div className="flex justify-between items-center">
                                  <span>
                                    {i18n.language === "ar"
                                      ? group.name_ar
                                      : group.name}
                                  </span>
                                </div>
                              ),
                            }))}
                            onSelect={(val) => {
                              SelectGroups(Number(val));
                              setTimeout(() => setGroupDropdownOpen(true), 0);
                            }}
                            onDeselect={(val) => {
                              SelectGroups(Number(val));
                              setTimeout(() => setGroupDropdownOpen(true), 0);
                            }}
                            placeholder={t("Select group")}
                            maxTagCount="responsive"
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Buttons */}
              <div className="grid grid-cols-3 gap-4 pt-4">
                {is_master_Store && (
                  <button
                    onClick={handleBack}
                    className="w-full px-2 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
                  >
                    {t("Back")}
                  </button>
                )}
                <button
                  disabled={fields.length === 0}
                  onClick={() =>
                    onExport(
                      fields,
                      selectedStores,
                      quantityFilter,
                      selectedGroupIds
                    )
                  }
                  className={`w-full px-2 py-2 rounded-lg font-semibold text-white ${
                    fields.length === 0
                      ? "bg-primaryBlue opacity-50 cursor-not-allowed"
                      : "bg-primaryBlue hover:bg-[#13316a]"
                  }`}
                >
                  {t("Export")}
                </button>
              </div>
            </>
          )}
        </div>
      </>
    )
  );
};

export default ExportInventoryModal;
